import {
  userSettingsService,
  eventInsightsService,
  reportingService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  SET_TIME_ZONE_ID,
  SET_DATE_RANGE,
  SET_EVENT_INSIGHTS_DATA,
  SET_LOADER_STATUS
} from './mutationTypes';

const actions = {
  async getReportingTimezoneId({ commit, rootGetters }) {
    const userSettings = await userSettingsService.getUserSettings();

    const timeZoneId = userSettings.timeZoneId || rootGetters.accountTimezoneId;
    
    commit(SET_TIME_ZONE_ID, timeZoneId);
    return timeZoneId;
  },

  setReportingTimezoneId({ commit }, timeZoneId) {
    commit(SET_TIME_ZONE_ID, timeZoneId);
  },

  async getEventInsights({ commit, getters, rootState }) {
    const data = {
      ...reportingService.getReportingDateRange(getters.timeRange, getters.translatedTimeZoneId),
      maxResultsPerGroup: 1000,
    };

    commit(SET_LOADER_STATUS, true);

    const response = await eventInsightsService.loadEventInsightsData(rootState.currentAccountId, data);

    commit(SET_EVENT_INSIGHTS_DATA, response);

    commit(SET_LOADER_STATUS, false);
  },

  setDateRange({ commit }, dateRangeDetails) {
    commit(SET_DATE_RANGE, dateRangeDetails);
  },
  
};

export default actions;